import React from 'react'
import { Link } from 'react-router-dom'
import user, {users} from './user'
import config from 'components/config'

class ChatMenu extends React.Component {
	constructor(props) {
		super(props);

		if (hp.store.chatSocket) {
			hp.store.chatSocket.subscribe('new-message', chat => {
				this.forceUpdate();
			});
		}
	}

	setChatState() {
		http.post('home/saveCustomUser.json', {chat_active: hp.store.chat_active == 0 ? 1 : 0}, (response, success) => {
			window.location.reload();
		})
	}

	render() {
		if (!user.isLoggedIn()) {
			return null;
		}
		const unread = hp.store.chat ? hp.store.chat.unread : {};
/*
		if (Object.keys(unread).length == 0) {
			return (
				<li className="nav-item">
					<Link to='/home/chat' className="btn btn-light">{__('socials_chat')}</Link>
				</li>
			);
		}
*/
		let n_users = {};

		// percorrer todas as mensagens unread
		let elements = Object.keys(unread).map(uid => {
			n_users[uid] = 1;
			return (
				<Link key={uid} to={'/home/chat/' + uid} className="dropdown-item d-flex justify-content-between align-items-center">
					<span>{users[uid].profile.name}</span>
					<span className="badge badge-secondary">{unread[uid]}</span>
				</Link>
			);
		});
		if (elements.length == 0) {
			elements = <Link to='/home/chat' className="dropdown-item">{__('socials_chat')}</Link>
		}
		return (
			<div className="dropdown">
				<button className="btn btn-light dropdown-toggle" data-toggle="dropdown">
					<em>{__('socials_chat')}</em>
					{elements.length > 0 ? <span className="badge badge-danger right">{Object.keys(n_users).length}</span> : null}
				</button>
				<div className="dropdown-menu dropdown-menu-right">
					{elements}
					<div className="dropdown-divider" />
					<button className="dropdown-item" onClick={this.setChatState.bind(this)}>
						<em className={classNames("la", hp.store.chat_active == 1 ? "la-sign-out" : "la-sign-in")} />
						{__(hp.store.chat_active == 1 ? 'socials_chat_disable' : 'socials_chat_enable')}
					</button>
				</div>
			</div>
		);
	}
}

export default class Header extends React.Component {
	logout() {
		http.post('/sessions/end.json', {}, (response, success) => {
			window.location = '/';
		});
	}

	changeLocale(locale) {
		window.location.assign(window.location.href.replace(/#+/, '').urlify({lang: locale}));
	}

	render() {
		const locale = hp.store.locales[hp.settings.locale] || {};
		const locales = Object.keys(hp.store.locales).map(code => {
			const l = hp.store.locales[code];
			return (
				<a key={code} href="#" onClick={this.changeLocale.bind(this, code)} className={classNames("dropdown-item pointer", code == hp.settings.locale ? "active" : null)}>
					<img src={"/public/admin/img/flags/" + l.idiom + ".png"} />
					<span>{l.country}</span>
				</a>
			);
		})
		const help_videos = (hp.store.help_videos || []).map(video =>
			<a key={video.id} target="_blank" href={video.href} className="dropdown-item pointer">
				<em className="la la-play" />
				<span>{video.name}</span>
			</a>
		)
		return (
			<nav className="navbar navbar-light navbar-expand-md header">
				<a className="navbar-brand" href="/"><img src="/public/template.510191266/ahk_logo.png" alt="AHK"/></a>
				<button className="navbar-toggler" type="button" data-toggle="collapse" data-target="#headerActions" aria-controls="headerActions" aria-expanded="false" aria-label="Toggle navigation">
					<span className="navbar-toggler-icon" />
				</button>
				<div className="collapse navbar-collapse" id="headerActions">
					<ul className="navbar-nav nav">
						{user.isLoggedIn()
							?	<li className="nav-item">
									<Link to='/home/profile' className="btn btn-light">{__('socials_my_page')}</Link>
								</li>
							:	<li className="nav-item">
									<a href={hp.store.makeme_partner.href} target="_blank" className="btn btn-light">{hp.store.makeme_partner.name}</a>
								</li>}
						<li className="nav-item">
							<Link to='/home/members' className="btn btn-light">{__('socials_partner_directory')}</Link>
						</li>
						<li className="nav-item">
							<Link to='/home/feed' className="btn btn-light">{__('socials_partner_pubs')}</Link>
						</li>


						<div className="dropdown">
							<button className="btn btn-light dropdown-toggle" data-toggle="dropdown">
								<span>{__('socials_ccila_info')}</span>
							</button>
							<div className="dropdown-menu">
								{hp.settings.locale == 'pt-pt' &&
									<>
										<a href='https://www.ccila-portugal.com/pt/infoteca/news' target='_blank' className="dropdown-item">
											<span>{__('news_index')}</span>
										</a>
										<div className="dropdown-divider" />
									</>
								}
								<a href={hp.settings.locale == 'pt-pt'
										? 'https://www.ccila-portugal.com/pt/infoteca/publicacoes'
										: 'https://www.ccila-portugal.com/infothek/publikationen'
									}
									className="dropdown-item"
									target='_blank'
								>
									<span>{__('socials_infoteca')}</span>
								</a>
								<div className="dropdown-divider" />
								<a href={hp.settings.locale == 'pt-pt'
										? 'https://www.ccila-portugal.com/pt/eventos'
										: 'https://www.ccila-portugal.com/events'
									}
									className="dropdown-item"
									target='_blank'
								>
									<span>{__('events_name')}</span>
								</a>
							</div>
						</div>

						<ChatMenu />
					</ul>
					<nav className="float-right">
						{/*<a className="btn btn-light" href="#" title="">
							<em className="la la-bell" />
						</a>*/}
						{!user.isLoggedIn()
							? <Link to='/home/login' className="btn btn-light"><em className="la la-user" /></Link>
							: <div className="dropdown">
								<button className="btn btn-light dropdown-toggle" data-toggle="dropdown">
									<em className="la la-user" />
								</button>
								<div className="dropdown-menu dropdown-menu-right">
									<Link to='/home/profile' className="dropdown-item">
										<em className="la la-address-card" />
										<span>{__('socials_my_profile')} ({hp.store.username})</span>
									</Link>
									<Link to='/personal/edit_profile.personal' className="dropdown-item" target="_blank">
										<em className="la la-pencil" />
										<span>{__('entities_edit')} (backoffice)</span>
									</Link>
									{
										hp.store.adm
											?	<a href="#" className="dropdown-item" onClick={() => config('@socials_site_config')}>
													<em className="la la-cogs" />
													<span>{__('attrs_configs')}</span>
												</a>
											: null
									}
									<div className="dropdown-divider" />
									<a href="#" className="dropdown-item" onClick={this.logout.bind(this)}>
										<em className="la la-sign-out" />
										<span>{__('users_end_session')}</span>
									</a>
								</div>
							 </div>
						}
						<div className="dropdown">
							<button title={locale.country} className="btn btn-light dropdown-toggle" data-toggle="dropdown">
								<img src={"/public/admin/img/flags/" + locale.idiom + ".png"} />
							</button>
							<div className="dropdown-menu dropdown-menu-right">
								{locales}
								<div className="dropdown-divider" />
								<div className="dropdown-header">{__('tips_help')}</div>
								<a target="_blank" href={`/media/help/manual-${hp.settings.locale}.pdf`} className="dropdown-item pointer">
									<em className="la la-book-open" />
									<span>{__('tips_manual')}</span>
								</a>
								{help_videos}
								<div className="dropdown-divider" />
								<div className="dropdown-header">{__('attrs_contact')}</div>
								<div className="dropdown-item" dangerouslySetInnerHTML={{__html: hp.store.help_contact}}/>
							</div>
						</div>
					</nav>
				</div>
			</nav>
		)
	}
}
